import { render, staticRenderFns } from "./new_order.vue?vue&type=template&id=2f8e7e62&lang=pug"
import script from "./new_order.vue?vue&type=script&lang=js"
export * from "./new_order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports